import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  DigitalMenuCategoryProposalItemApi,
  FindProposalItemsForMenuCategoryOption,
} from '../api/digitalMenuCategoryProposalItem';

export const findProposalItemsForMenuCategory = createAsyncThunk(
  'digitalMenuCategoryProposalItem/findProposalItemsForMenuCategory',
  async (
    {
      digitalMenuCategoryID,
      option,
    }: {
      digitalMenuCategoryID: string;
      option: FindProposalItemsForMenuCategoryOption;
    },
    { rejectWithValue }
  ) => {
    try {
      const response =
        await DigitalMenuCategoryProposalItemApi.findProposalItemsForMenuCategory(
          digitalMenuCategoryID,
          option
        );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeDigitalMenuCategoryProposalItem = createAsyncThunk(
  'digitalMenuCategoryProposalItem/removeDigitalMenuCategoryProposalItem',
  async (digitalMenuCategoryProposalItemID: any, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuCategoryProposalItemApi.delete(
        digitalMenuCategoryProposalItemID
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeDigitalMenuCategoryProposalItems = createAsyncThunk(
  'digitalMenuCategoryProposalItem/removeDigitalMenuCategoryProposalItems',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuCategoryProposalItemApi.deleteMulti(
        body
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateStatusDigitalMenuCategoryProposalItem = createAsyncThunk(
  'digitalMenuCategoryProposalItem/updateStatusDigitalMenuCategoryProposalItem',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;

      const response = await DigitalMenuCategoryProposalItemApi.updateStatus(
        id,
        body
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createMultiDigitalMenuCategoryProposalItem = createAsyncThunk(
  'digitalMenuCategoryProposalItem/createMultiDigitalMenuCategoryProposalItem',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuCategoryProposalItemApi.createMulti(
        body
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  reloadFlag: boolean;
  tableList: Array<any>;
  myList: Array<any>;
  purchaseList: Array<any>;
  purchaseReloadedRow?: any;
  collaboratorList: Array<any>;
  list: Array<any>;
  isLoadingTable: boolean;
}

const initialState: IState = {
  reloadFlag: false,
  tableList: [],
  myList: [],
  purchaseList: [],
  purchaseReloadedRow: undefined,
  collaboratorList: [],
  list: [],
  isLoadingTable: true,
};

const digitalMenuCategoryProposalItemSlice = createSlice({
  name: 'digitalMenuCategoryProposalItem',
  initialState,
  reducers: {
    reloadDigitalMenuCategoryProposalItem(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
});

const { actions, reducer: digitalMenuCategoryProposalItemReducer } =
  digitalMenuCategoryProposalItemSlice;

export const { reloadDigitalMenuCategoryProposalItem } = actions;

export default digitalMenuCategoryProposalItemReducer;
